<template>
  <b-container fluid>
    <b-row>
      <b-col>

        <b-card title="User" class="mb-2">

          <b-form v-on:submit.prevent="onSubmit" v-if="show">
            <b-button-group>
              <b-button :disabled="!passwordValidation" type="submit" variant="primary">{{'UPDATE' | i18n}}</b-button>
              <b-button v-if="details.canActAs" class="ml-1" variant="danger" @click="onSimulate">{{'SIMULATE' | i18n}}</b-button>
              <b-button  :disabled="!passwordValidation || didInvite" @click="onInvite" variant="primary">Send Invitation</b-button>
            </b-button-group>

            <b-form-group id="input-group-1" label="User name:" label-for="input-1">
              <b-form-input id="input-1" v-model="details.username" type="text" required placeholder="Enter email"></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-2" label="Name:" label-for="input-2">
              <b-form-input id="input-2" v-model="details.name" required placeholder="Enter name"></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-3" label="Locale:" label-for="input-3">
              <b-form-select id="input-3" v-model="details.locale" :options="details.availableLocales" required></b-form-select>
            </b-form-group>

            <b-form-group id="input-group-password" label="Password:" label-for="input-2">
              <b-form-input id="user-password" v-model="details.password" type="password" placeholder="Enter password"></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-password-repeat" label="Repeat password:" label-for="input-2">
              <b-form-input id="user-repeat-password" v-model="details.repeatPassword" type="password" placeholder="Enter password" :state="passwordValidation"></b-form-input>
              <b-form-invalid-feedback :state="passwordValidation">Passwords mismatch</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group id="input-group-4">
              <b-form-checkbox v-model="details.enabled" id="checkboxes-4">
                Enabled
              </b-form-checkbox>
            </b-form-group>

          </b-form>
        </b-card>


      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import PageNavigator from "../../services/PageNavigator";

export default {
    name: 'UserDetailsComponent',

    data() {
      return {
        repeatPassword: "",
        show: true,
        invited: null
      }
    },

    props: {
      details: Object
    },

    computed: {
      ...mapState(['activeStudy', 'activeView', 'absoluteDrillPath']),
      ...mapGetters(['realmName', 'studyName', 'authToken', 'completePath']),

      passwordValidation() {
        return this.details.repeatPassword===this.details.password
      },

      didInvite() {
        return this.invited && this.invited===this.details.username
      }

    },

    methods: {
      onSubmit() {
        this.$emit('update-details', this.details)
        this.invited = null
      },

      onInvite() {
        this.$emit('update-details-invite', this.details)

        this.$bvToast.toast(`Invitation sent`, {
          autoHideDelay: 3000,
          variant: "info",
          solid: true,
          noCloseButton: true,
          appendToast: true
        })

        this.invited = this.details.username
      },

      onSimulate() {
        this.$store.dispatch('actAsUser', this.details.userid).then(() => {
          PageNavigator.navigateToDefaultPage(this.$router, this.activeStudy.defaultPage, this.activeStudy.extname, this.activeView.extname, this.activeView.defaultPath)
        })
      }

    },

  }
</script>